import React, { useEffect, useState } from "react";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Grid, Select, FormControl, MenuItem, Typography, Button, Box, Alert } from '@mui/material';

// Setting Test
import { backendApi } from '../../../components/Api';
import { GetGA4Info } from '../../../components/Api';
import { useNavigate, useLocation } from "react-router-dom";
import ga4Logo from './../../../assets/images/ga4.png';
import Loading from '../../../components/Loading'
const serverUrl = process.env.REACT_APP_SERVER_URL

export default function SelectAccount(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [account, setAccount] = useState(props.accounts ? props.accounts : []);
  const [property, setProperties] = useState([]);
  const [accountId, setAccountId] = useState("");
  const [propertyId, setPropertyId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const accessToken = props?.accessToken ? props?.accessToken : localStorage.getItem('access_token');
  const GA4Url = process.env.REACT_APP_GA4_URL
  const apiKey = process.env.REACT_APP_API_KEY
  const [loading, setLoading] = useState(true);
  let userDetails = localStorage.getItem('userDetails')
  userDetails = userDetails !== 'undefined' ? JSON.parse(userDetails) : userDetails
  let [accountName, setAccountName] = useState("")
  let [propertyName, setPropertyName] = useState("")

  const handleSubmit = async () => {
    if (propertyId?.startsWith('properties') && accountId) {
      const body =
      {
        user_id: userDetails.id,
        account: accountId,
        property: propertyId,
        accountName: accountName,
        propertyName: propertyName,
        tool: "GA4"
      }
      setLoading(true)
      let accountDetails = await backendApi(`${serverUrl}api/accounts`, body, userDetails.jwt_access_token)
      localStorage.setItem('accountDetails', JSON.stringify(accountDetails.data))
      localStorage.setItem('access_token', accessToken)
      navigate('/confirm-details', { state: { accountDetails, userDetails, accessToken } })
    }
    else { console.log("All fields required!"); }
  };
  useEffect(() => {
    if (accessToken) {
      setAccount(props.accounts)
    }
    if(account.length === 0){
      setErrorMessage("No analytics accounts available!")
    }
  }, []);

  useEffect(() => {
    if (!userDetails) {
      navigate('/')
    }
  }, []);

  const propertyList = async (e) => {
    let selected_acc = e.target.value.split(/,(.*)/s)
    setProperties([])
    setPropertyId('')
    setAccountId((selected_acc[0]))
    setAccountName(selected_acc[1])
    setLoading(true)
    let params = {
      filter: `parent:accounts/${selected_acc[0]}`,
      key: apiKey
    }
    let GAUrl = `${GA4Url}/properties`;
    let GA4Propertys = await GetGA4Info(GAUrl, params, accessToken)

    let status = GA4Propertys?.response?.data?.error?.status
    if (status === "PERMISSION_DENIED" || status === "UNAUTHENTICATED") {
      setErrorMessage('Insufficient authentication access')
      setLoading(false)
      localStorage.clear()
      navigate('/', { state: {} })
      return
    }

    GA4Propertys = GA4Propertys?.properties ? GA4Propertys.properties : []
    if (GA4Propertys.length === 0) {
      setErrorMessage('No properties available in this account!')
      setTimeout(() => {
        setErrorMessage("")
      }, 5000);
      setLoading(false)
      return
    }

    GA4Propertys.sort((a, b) => {
      if (a.displayName < b.displayName)
        return -1;
      if (a.displayName > b.displayName)
        return 1;
      return 0;
    })
    setProperties(GA4Propertys)
    setErrorMessage("")
  }

  const propertyDetails = (e) => {
    let selected_property = e.target.value.split(/,(.*)/s)
    setPropertyId(selected_property[0])
    setPropertyName(selected_property[1])
  }

  return (
    <Box>
      <Box>
        <Box marginBottom={{xs:1.5, sm:3, md:4}}>
          <Typography id="transition-modal-title" variant="h4" component="h4" fontWeight={'bold'} fontSize={{xs:22, sm:30, md:34}}>
            Select a property
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="subtitle1"
            color="error.main"
            gutterBottom
          >
            {errorMessage ?
              <Alert style={{ marginTop: '15px' }} severity="error">{errorMessage}</Alert> : ''}
          </Typography>
          <Grid container spacing={{xs:1, sm:2}}>
            <Grid item xs={12} md={6}>
              <Typography
                fontWeight={700}
                marginBottom={{xs:0.1, sm:0.7}}
              >
                Account
              </Typography>
              <FormControl required sx={{ m: 0, minWidth: 1, maxWidth: 1 }}>
                <Select
                  variant="outlined"
                  onChange={propertyList}
                  fullWidth
                >
                  {account.length > 0 && (account.sort((a, b) => b.name - a.name)).map((acc,index) =>
                    <MenuItem key={`acc-${index}`} value={`${acc.id},${acc.name}`} > {acc.name}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                fontWeight={700}
                marginBottom={{xs:0.1, sm:0.7}}
              >
                Property
              </Typography>

              <FormControl required sx={{ m: 0, minWidth: 1, maxWidth: 1 }}>
                {!property.length > 0 && accountId ?
                  <Loading loading={loading} /> :
                  <Select
                    disabled={!property.length > 0 ? true : false}
                    defaultValue={'Select Property'}
                    variant="outlined"
                    onChange={propertyDetails}
                    fullWidth
                  >
                    {property?.map((pro,index) =>
                      <MenuItem  key={`pro-${index}`} value={`${pro.name},${pro.displayName}`}> {pro.displayName}
                        <Box sx={{display: 'inline-block', verticalAlign: 'middle'}}>
                          <Box
                            borderRadius={1}
                            marginLeft={1}
                            component={'img'}
                            src={ga4Logo}
                            maxWidth={1}
                          />
                        </Box>
                      </MenuItem>
                    )}
                  </Select>
                }
              </FormControl>
            </Grid>
          </Grid>
          <Box textAlign={'center'} marginTop={{xs:2, sm:5}}>
            <Button
              className="theme-btn"
              onClick={handleSubmit}
              disabled={propertyId?.startsWith('properties') && accountId ? false : true}
              endIcon={<ArrowForward />} sx={{ minWidth: 180 }}>
              <span> Submit </span>
            </Button>
          </Box>
        </Box>
      </Box>
    </Box >
  );
}
